/* ============================================================
   PEMILIH "LALUAN POST" FACEBOOK REELS — Control Panel v3.9 (2026-09-26)
   RUPA SAHAJA. Nilai + simpanan dalam App.jsx (`fbLaluan`/`pilihFbLaluan`) dan
   utils/laluanFb.js (sebab, kunci storan, cara ia sampai ke robot).
   Rupa: dua kad ikon "pilih satu" (pilihan B, diluluskan user 2026-09-27) —
   monokrom, tiada emoji. ★ [2026-09-29] Kad dipilih = isian gelap bertulisan
   cerah (dahulu bingkai tebal), SAMA seperti pilihan aktif Cara post dan
   kotak Post To (`PostToV39`) — arahan user. Ubah satu, semak yang lain.
   ============================================================ */

const PILIHAN = [
    { id: 'contentlibrary', ikon: 'grid_view', label: 'Content Library' },
    { id: 'page', ikon: 'flag', label: 'Page' },
];

export default function LaluanFbV39({ t, laluan, onPilih }) {
    const semasa = laluan === 'page' ? 'page' : 'contentlibrary';
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
            <p className="s-sect__title" style={{ fontSize: 12, margin: 0 }}>
                {t('workspace.fblaluan.title', 'Laluan post')}
            </p>
            <div role="radiogroup" aria-label={t('workspace.fblaluan.title', 'Laluan post')}
                style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                {PILIHAN.map((p) => {
                    const on = semasa === p.id;
                    return (
                        <button
                            key={p.id}
                            type="button"
                            role="radio"
                            aria-checked={on}
                            onClick={() => onPilih(p.id)}
                            style={{
                                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                                padding: '10px 7px', cursor: 'pointer', font: 'inherit',
                                borderRadius: 'var(--s-r)', background: on ? 'var(--s-primary)' : 'var(--s-fill)',
                                border: on ? '1px solid var(--s-primary)' : '1px solid var(--s-line-strong)',
                                color: on ? 'var(--s-primary-ink)' : 'var(--s-ink-3)',
                            }}
                        >
                            <span className="material-symbols-outlined" style={{ fontSize: 20 }}>{p.ikon}</span>
                            <span style={{ fontSize: 12, fontWeight: on ? 700 : 500 }}>{p.label}</span>
                        </button>
                    );
                })}
            </div>
            <p className="s-hint" style={{ margin: 0 }}>
                {t('workspace.fblaluan.hint', 'Pilih laluan yang beg Shopee muncul di phone.')}
            </p>
        </div>
    );
}
